var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isVisible,"content-class":_vm.contentClass,"persistent":"","fullscreen":_vm.isFullscreen,"attach":_vm.attach}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }